module.exports = __webpack_public_path__ + "img/picture.77728323.png";